// This file was autogenerated by dynamically running setEnv.ts and using dotenv for managing API key secrecy
export const environment = {
  production: true,
  clientId: 'f8ae020e-2498-4c37-97b4-38eb648efa3f',
  authority: 'https://login.microsoftonline.com/5b35a395-4725-43fc-b044-7ef659848482',
  redirectUri: 'https://idpuseradminweb.azureedge.net/',
  postLogoutRedirectUri: 'https://idpuseradminweb.azureedge.net/',
  adminGroupID: 'e50a63f3-ed10-4948-80d8-99690c29239c',
  viewerGroupID: '0b3046e5-8d14-4f76-b73e-5a26ad43a528',
  superAdminGroupID: '7fffae02-fafe-41cd-acba-e57b8bf58c03',
  idpUserAdminAPI: 'https://preprod-api.gildedco.com/dev-idp-user-admin',
  ocpApimSubscriptionValue: 'a044a3a5d1b1497a9f2c8048433c71bf',
  color: 'red',
  environmentTitle: 'DEV-Web Admin Client'
};
